import React from 'react';
import Trophy from './components/Trophy';
import EmptyTrophyCase from './components/EmptyTrophyCase';
import JoinStravaCTA from '../../components/JoinStravaCTA';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';
import styles from './Trophies.module.scss';

const Trophies = () => {
  const { state, t } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete, trophies } = athleteData;

  return (
    <div className={styles.trophies}>
      <h3>{t('trophy_case')}</h3>

      {trophies.length > 0 ? (
        <ul className={styles.list}>
          {trophies.map((trophy) => (
            <li className={styles.listItem} key={trophy.challenge_id}>
              <Trophy trophy={trophy} />
            </li>
          ))}
        </ul>
      ) : (
        <EmptyTrophyCase
          athleteName={athlete.name}
          followUrl={athlete.followUrl}
        />
      )}

      <JoinStravaCTA
        heading={t('add_trophies')}
        linkConfig={{
          href: '/challenges',
          text: t('join_cta')
        }}
        trackConfig={{
          element: 'join_challenge'
        }}
      />
    </div>
  );
};

export default Trophies;
